import '../styles/style.scss';
import lazySizes from "lazysizes";
import './tools/lazybg';
import './tools/sharer';
import './tools/burger';
import './tools/backToTop';

const thankYou = document.getElementById("thank-you");
if(thankYou) {
  console.log('thank you')
  thankYou.scrollIntoView({ behavior: 'smooth', block: 'start' });  
}


